export default __webpack_public_path__ + "static/media/line_sticker.dd3e8351.png";